class Ping {
    static createInstance() {
        return new this();
    }

    addToCart() {
        let rules = {
            contents: {
                required: true,
                default: [],
                value: this.cartToContents(arguments[0].items),
            },
            currency: { required: true, default: "HUF", value: arguments[0].currency },
            revenue: { required: true, default: 0, value: arguments[0].revenue },
        };

        const properties = this.rulesToProperties(rules);
        this.barionEvent("track", "addToCart", properties);
        this.googleAnalyticsEvent("add_to_cart", properties);
        this.pinterestEvent("track", "AddToCart", {
            value: properties.contents[properties.contents.length-1].unitPrice,
            order_quantity: 1,
            currency: 'HUF',
        });
        if(properties.contents.length > 0)
            this.facebookEvent("AddToCart", properties.contents[properties.contents.length-1]);
    }

    initiatePurchase() {
        let rules = {
            contents: {
                required: true,
                default: [],
                value: this.cartToContents(arguments[0].cart),
            },
            currency: { required: true, default: "HUF", value: arguments[0].currency },
            revenue: { required: true, default: 0, value: arguments[0].revenue },
            value: { required: true, default: 0, value: arguments[0].revenue },
            step: { required: true, default: 1, value: arguments[0].step },
        };

        const properties = this.rulesToProperties(rules);
        this.googleAnalyticsEvent("initiate_purchase", properties);
        this.barionEvent("track", "initiatePurchase", properties);
    }

    finalizePurchase() {
        let rules = {
            contents: {
                required: true,
                default: [],
                value: this.cartToContents(arguments[0].cart),
            },
            currency: { required: true, default: "HUF", value: arguments[0].currency },
            revenue: { required: true, default: 0, value: arguments[0].revenue },
            value: { required: true, default: 0, value: arguments[0].revenue },
            step: { required: true, default: 1, value: arguments[0].step },
        };

        const properties = this.rulesToProperties(rules);
        this.googleAnalyticsEvent("finalize_purchase", properties);
        this.barionEvent("track", "finalizePurchase", properties);
    }

    categorySelection() {
        let rules = {
            id: {
                required: true,
                default: "0",
                value: String(arguments[0].id),
            },
            name: {
                required: true,
                default: "",
                value: arguments[0].name,
            },
            _location: {
                required: false,
                default: "",
                value: arguments[0]._location,
            },
        };

        let properties = this.rulesToProperties(rules);

        this.barionEvent("track", "categorySelection", properties);
    }

    removeFromCart() {
        const rules = {
            contents: {
                required: true,
                default: [],
                value: this.cartToContents(arguments[0].items ?? []),
            },
            currency: { required: true, default: "HUF", value: arguments[0].currency },
            revenue: { required: true, default: 0, value: arguments[0].revenue },
        };

        let properties = this.rulesToProperties(rules);
        this.barionEvent("track", "removeFromCart", properties);
        this.googleAnalyticsEvent("remove_from_cart", properties);
    }

    addPaymentInfo() {
        let rules = {
            contents: {
                required: true,
                default: [],
                value: this.cartToContents(arguments[0].cart),
            },
            paymentMethod: {
                required: true,
                default: "",
                value: arguments[0].paymentMethod,
            },
            step: {
                required: true,
                default: 1,
                value: arguments[0].step,
            },
        };

        let properties = this.rulesToProperties(rules);

        this.barionEvent("track", "addPaymentInfo", properties);
    }

    clickPromo() {
        let rules = {
            contentType: {
                required: true,
                default: "Page",
                value: arguments[0].contentType,
            },
            creative: {
                required: true,
                default: "",
                value: arguments[0].lead,
            },
            id: {
                required: true,
                default: "0",
                value: String(arguments[0].id),
            },
            name: {
                required: true,
                default: "",
                value: arguments[0].title,
            },
        };

        let properties = this.rulesToProperties(rules);

        this.barionEvent("track", "clickPromo", properties);
    }

    search() {
        let rules = {
            searchString: {
                required: true,
                default: "",
                value: arguments[0].searchString,
            },
        };

        let properties = this.rulesToProperties(rules);

        this.barionEvent("track", "search", properties);
    }

    googleAnalyticsEvent(event, properties, type = "product") {
        if (typeof gtag === "undefined") return;

        const data =
            type === "product"
                ? {
                      currency: properties.currency,
                      value: properties.revenue,
                      items: properties.contents,
                  }
                : properties;

        gtag("event", event, data);
    }

    barionEvent(event, eventName, properties) {
        if (typeof window.bp !== "undefined") {
            window.bp(event, eventName, properties);
        }
    }

    facebookEvent(eventName, data) {
        if (typeof window.fbq !== "undefined") {
            window.fbq("track", eventName, {
                content_name: data.name,
                content_ids: [data.isbn],
                content_type: data.contentType,
                value: data.unitPrice,
                currency: data.currency,
            });
        }
    }

    pinterestEvent(event, eventName, properties) {
        if (typeof window.pintrk !== "undefined") {
            pintrk(event, eventName, properties); 
        }
    }

    cartToContents(cart) {
        return cart.map((item) => ({
            contentType: "Product",
            currency: "HUF",
            id: String(item.id),
            isbn: String(item.isbn),
            name: item.title,
            quantity: 1,
            totalItemPrice: item.price,
            revenue: item.price,
            unit: "db",
            unitPrice: item.price,
            publisher: item.publisher,
        }));
    }

    rulesToProperties(rules) {
        let properties = {};
        for (let key in rules) {
            if (rules[key].required) properties[key] = rules[key].value || rules[key].default;
            else if (rules[key].value) properties[key] = rules[key].value;
        }
        return properties;
    }

    newsletterSignup() {
        const rules = {
            email: { required: true, default: "", value: arguments[0].email },
            name: { required: true, default: "", value: arguments[0].name },
            categories: { required: true, default: [], value: arguments[0].categories },
        };

        const properties = this.rulesToProperties(rules);
        this.googleAnalyticsEvent("newsletter_signup", properties, "other");
    }
}

export default Ping;
